import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import { AdditionalEquipment } from "services/api/catalog/cvh/types";
import { classNames } from "helpers";

export const EQUIPMENT_COLUMNS_SEARCH_COLUMNS: Column[] = [
  {
    title: "Naziv",
    type: ColumnTypes.custom,
    field: "name",
    render: (row: AdditionalEquipment) => {
      return (
        <div className={row.included ? "bg-green-50 -mx-4 -my-2 px-4 py-2" : ""}>
          <div className={classNames("font-medium uppercase", row.included ? "text-green-800" : "text-slate-900")}>{row.name}</div>
          <div className={classNames("text-sm max-w-[300px] overflow-hidden text-ellipsis line-clamp-2", row.included ? "text-green-600" : "text-slate-500")}>{row.description}</div>
        </div>
      );
    },
  },
  {
    title: "Cijena EUR",
    type: ColumnTypes.custom,
    field: "priceEur",
    render: (row: AdditionalEquipment) => {
      return (
        <div className={row.included ? "bg-green-50 -mx-4 -my-2 px-4 py-2 text-green-800" : ""}>
          {row.priceEur ? `${row.priceEur.toLocaleString("hr-HR")} €` : "-"}
        </div>
      );
    },
  },
  {
    title: "Konačna cijena EUR",
    type: ColumnTypes.custom,
    field: "finalPriceEur",
    render: (row: AdditionalEquipment) => {
      return (
        <div className={row.included ? "bg-green-50 -mx-4 -my-2 px-4 py-2 text-green-800" : ""}>
          {row.finalPriceEur ? `${row.finalPriceEur.toLocaleString("hr-HR")} €` : "-"}
        </div>
      );
    },
  },
];
